<template lang="html">
  <section main>
    <dsbn-header></dsbn-header>
    <main-hero >
      <aside>
        <button type="button" class="button">Book Now</button>
      </aside>
    </main-hero>
    <adventure-content></adventure-content>
    <contact-form></contact-form>
  </section>
</template>

<script>
import DsbnHeader from '~/tags/DSBNHeader.vue'
import MainHero from '~/tags/MainHero.vue'
import ContactForm from '~/tags/ContactForm.vue'
import AdventureContent from '~/tags/Content.vue'

export default {
  components: {
    DsbnHeader,
    MainHero,
    ContactForm,
    AdventureContent
  }
}
</script>

<style lang="less">
@import url( 'https://fonts.googleapis.com/css?family=Cantarell:700,400|Raleway:400,500,700');
@import "../css/variables";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Cantarell';
  font-size: 18px;
}

h1, h2, h3, h4, h5, blockquote {
  font-family: 'Raleway';
  font-weight: 400;
}

a,a:visited {
  color: @adventure-primary;
  text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// AdventureCampus.vue?e82563be